<template>
  <div>
    <b-row v-if="checkAccessPrivilege('Payment.Whitelist.Withdraw.Search')">
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form inline>
              <label class="mr-sm-2" for="sUsername">Username </label>
              <b-input id="sUsername" type="text" placeholder="" v-model.trim="sUsername"></b-input>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b-button variant="primary" @click="queryWhitelist"><i class="fa fa-search"></i> Search</b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-money'></i> Withdraw Whitelist</h3>
              <div class="float-right">
                <b-button variant="primary" @click="showBatchUploadModal" v-if="checkAccessPrivilege('Payment.Whitelist.Withdraw.BatchUpload')">Batch Upload</b-button>&nbsp;&nbsp;&nbsp;&nbsp;
                <b-button variant="primary" class="float-right" @click="showManagementModal" v-if="checkAccessPrivilege('Payment.Whitelist.Withdraw.Management')">Whitelist Management</b-button>
              </div>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(action)="data">
                <b-button variant="info" @click="manageUserBank(data.item.MemberId)" v-if="checkAccessPrivilege('Payment.Whitelist.Withdraw.ManageBank')">Manage Bank</b-button>
                <b-button variant="danger" @click="removeWhitelist(data.item.Id, data.item.MemberId, data.item.Username)" v-if="checkAccessPrivilege('Payment.Whitelist.Withdraw.Remove')">Remove</b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="showBatchUploadModal" size="lg" centered header-bg-variant="primary" hide-footer title="Batch Upload Member Bank Data">
      <div class="mb-3">
        <label for="groupId">Upload File</label>
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="customFile" @change="handleFileChange">
          <label class="custom-file-label" for="customFile">{{ form.batchUpload.uploadedFileName }}</label>
        </div>
        <small id="passwordHelpBlock" class="form-text text-muted">
          Suppported extension (.xlsx | .xls)
        </small>
        <div v-if="$v.form.batchUpload.uploadFile.$error">
          <div class="invalid-feedback d-block" v-if="!$v.form.batchUpload.uploadFile.required">Please upload file.</div>
          <div class="invalid-feedback d-block" v-if="!$v.form.batchUpload.uploadFile.fileType">Invalid File Format. Must be (.xlsx | .xls)</div>
        </div>
      </div>
      <b-button variant="success" @click="submitBatchUpload" :disabled="$v.form.batchUpload.$error">Upload</b-button>
      <b-button variant="outline-danger" @click="cancelBatchUploadModal">Cancel</b-button>
    </b-modal>

    <b-modal ref="showUserBankListVerification" centered header-bg-variant="primary" hide-footer title="Select Verified User Bank">
      <div class="d-block">
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="userBankList" :fields="userBankTable">
          <template v-slot:cell(action)="data">
            <b-button variant="success" @click="verifyBank(selectMemberId, data.item.Id)" v-if="data.item.Verify === 0">Verify Bank</b-button>
            <b-button variant="danger" @click="rejectBank(selectMemberId, data.item.Id)" v-if="data.item.Verify === 1">Reject Bank</b-button>
          </template>
        </b-table>
        <b-button variant="outline-danger" @click="closeUserBankListVerification">Close</b-button>
      </div>
    </b-modal>

    <b-modal ref="showManagementModal" size="lg" header-bg-variant="primary" hide-footer title="Whitelist Management">
      <div class="d-block">
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="12">
                <b-form-group :state="!$v.searchName.$error">
                  <b-input-group>
                    <b-form-input type="text" placeholder="Enter Username for Search" v-model.trim="searchName" :state="$v.searchName.$error?false:null" @focus.native="$v.searchName.$touch"></b-form-input>
                    <b-input-group-button class="input-group-append">
                      <b-btn variant="success" @click="searchMember" :disabled="$v.searchName.$invalid">
                        <i class="fa fa-search"></i> Search
                      </b-btn>
                    </b-input-group-button>
                  </b-input-group>
                  <div v-if="$v.searchName.$error">
                    <div class="invalid-feedback d-block" v-if="!$v.searchName.required">Username is required</div>
                    <div class="invalid-feedback d-block" v-else-if="!$v.searchName.minLength">Must have at least {{ $v.searchName.$params.minLength.min}} letters</div>
                    <div class="invalid-feedback d-block" v-else-if="!$v.searchName.maxLength">Must no exceed {{ $v.searchName.$params.maxLength.max}} letters</div>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="members" :fields="memberFields" :current-page="memberCurrentPage" :per-page="memberPerPage">
                  <template v-slot:cell(action)="data">
                    <b-button variant="danger" @click="addWhitelist(data.item.Id, data.item.Username)">Add</b-button>
                  </template>
                </b-table>
                <nav>
                  <b-pagination :total-rows="getMemberRowCount(members)" :per-page="memberPerPage" v-model="memberCurrentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                </nav>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <b-btn class="mt-3" variant="outline-danger" @click="hideManagementModal">Cancel</b-btn>
    </b-modal>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  const {required, minLength, maxLength} = require('vuelidate/lib/validators')
  export default {
    name: 'withdraw-whitelist-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        members: [],
        fields: [
          {key: 'Id', label: 'ID'},
          {key: 'Username', label: 'Username'},
          {key: 'action', label: 'Action'}
        ],
        memberFields: [
          {key: 'Id', label: 'ID'},
          {key: 'Username', label: 'Username'},
          {key: 'action', label: 'Action'}
        ],
        userBankTable: [
          {key: 'BankName', label: 'Bank Name'},
          {key: 'action', label: 'Action'}
        ],
        currentPage: 1,
        memberCurrentPage: 1,
        perPage: 10,
        memberPerPage: 10,
        totalMemberRows: 0,
        operator: '',
        searchName: '',
        userBankList: [],
        sUsername: '',
        selectMemberId: '',
        form: {
          batchUpload: {
            uploadedFileName: 'Choose File',
            uploadFile: ''
          }
        }
      }
    },
    validations: {
      searchName: { required, minLength: minLength(5), maxLength: maxLength(20) },
      form: {
        batchUpload: {
          uploadFile: {
            required,
            fileType: function (e) {
              if (!e) return true
              let type = e.name ? e.name.split('.').reverse()[0] : ''
              return (type !== '' && (type === 'xlsx' || type === 'xls'))
            }
          }
        }
      }
    },
    watch: {
      currentPage: function () {
        this.queryWhitelist()
      },
      currentMemberPage: function () {
        this.searchMember()
      }
    },
    methods: {
      handleFileChange (e) {
        this.form.batchUpload.uploadedFileName = e.target.files[0].name
        this.form.batchUpload.uploadFile = e.target.files[0]
      },
      getRowCount (items) {
        return items.length
      },
      getMemberRowCount (members) {
        return members.length
      },
      searchMember () {
        this.$http.post(this.API_ENDPOINT + '/member/search', {searchName: this.searchName}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.members = response.data.members
          this.totalMemberRows = response.data.members.length
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      queryWhitelist () {
        let username = this.sUsername
        let queryStr = `?username=${username}`
        this.$http.get(this.API_ENDPOINT + '/payment/withdraw/whitelist/query' + queryStr, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.items
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      removeWhitelist (id, memberId, username) {
        this.$http.post(this.API_ENDPOINT + '/payment/withdraw/whitelist/remove', {'id': id, 'memberId': memberId, 'username': username, 'operator': this.operator}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.queryWhitelist()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Removed from whitelist.')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      addWhitelist (memberId, username) {
        this.$http.post(this.API_ENDPOINT + '/payment/withdraw/whitelist/add', {'memberId': memberId, 'username': username, 'operator': this.operator}, {headers: { 'Content-Type': 'application/json' }}).then(async response => {
          if (response.status === 200) {
            this.queryWhitelist()
            await this.getUserBankList(memberId)
            this.hideManagementModal()
            this.showUserBankListVerification(memberId)
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Added into whiteist.')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      async getUserBankList (memberId) {
        try {
          let response = await this.$http.get(this.API_ENDPOINT + '/payment/withdraw/whitelist/getUserBankList/' + memberId, {
            headers: { 'Content-Type': 'application/json' }
          })
          this.userBankList = response.data.bankList
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      manageUserBank (memberId) {
        this.getUserBankList(memberId)
        this.showUserBankListVerification(memberId)
      },
      showUserBankListVerification (memberId) {
        this.selectMemberId = memberId
        this.$refs.showUserBankListVerification.show()
      },
      closeUserBankListVerification () {
        this.selectMemberId = ''
        this.$refs.showUserBankListVerification.hide()
      },
      showManagementModal () {
        this.$refs.showManagementModal.show()
      },
      hideManagementModal () {
        this.$refs.showManagementModal.hide()
      },
      showBatchUploadModal () {
        this.$refs.showBatchUploadModal.show()
      },
      cancelBatchUploadModal () {
        this.form.batchUpload.uploadedFileName = ''
        this.form.batchUpload.uploadFile = ''
        this.$v.form.batchUpload.$reset()
        this.$refs.showBatchUploadModal.hide()
      },
      async verifyBank (memberId, bankId) {
        try {
          await this.$http.post(this.API_ENDPOINT + '/payment/withdraw/whitelist/bank/add', {
            memberId: memberId,
            bankId: bankId
          }, {
            headers: { 'Content-Type': 'application/json' }
          })
          this.getUserBankList(memberId)
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      async rejectBank (memberId, bankId) {
        try {
          await this.$http.post(this.API_ENDPOINT + '/payment/withdraw/whitelist/bank/remove', {
            memberId: memberId,
            bankId: bankId
          }, {
            headers: { 'Content-Type': 'application/json' }
          })
          this.getUserBankList(memberId)
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      async submitBatchUpload () {
        try {
          this.$v.form.batchUpload.$touch()
          if (this.$v.form.batchUpload.$error) {
            return true
          } else {
            let data = new FormData()
            data.append('file', this.form.batchUpload.uploadFile)
            // data.append('operator', this.operator)

            await this.$http.post(this.API_ENDPOINT + '/payment/withdraw/whitelist/bank/batchUpload', data)
            this.queryWhitelist()
            this.cancelBatchUploadModal()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Batch Member Uploaded Successfully')
          }
        } catch (error) {
          console.log('this is an error', error)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      }
    },
    created () {
      let user = JSON.parse(window.sessionStorage.getItem('user'))
      this.operator = user.username
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/withdraw/WhitelistTable.vue